import styled from 'styled-components'
import statsLogo from '../../images/Stats.svg'
import Select from 'react-select'

export const DashboardContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: -50px;
  padding-top: 30px;
  position: relative;
`

export const Bg = styled.div`
  min-height: 100vh;
  height: 100vh;
  width: 100%;
  background: white;
`

export const MainContainer = styled.div`
  margin: auto;
  position: relative;
  width: 52%;
  padding-top: 1rem;

  @media (max-width: 1200px) {
    width: 72%;
  }

  @media (max-width: 800px) {
    width: 92%;
  }
`

export const MainLayout = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  width: 80%;
  background-color: white;

  @media (max-width: 1024px) {
    width: 100%;
  }
`

export const TopMetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.9rem;
  margin-bottom: 1rem;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const MetricCard = styled.div`
  background: #ffffff;
  border: 1px solid #e1e7f2;
  border-radius: 14px;
  padding: 0.95rem 1rem;
  box-shadow: 0 8px 20px rgba(14, 41, 72, 0.05);
`

export const MetricLabel = styled.div`
  font-family: Poppins;
  font-size: 0.84rem;
  color: #5f7090;
  margin-bottom: 0.35rem;
`

export const MetricValue = styled.div`
  font-family: Poppins;
  font-size: 1.28rem;
  font-weight: 700;
  color: #12345f;
`

export const SkillSection = styled.div`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e1e7f2;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 1.1rem;
  box-shadow: 0 10px 24px rgba(14, 41, 72, 0.06);
  margin-bottom: 1rem;
`

export const SkillSectionTitle = styled.div`
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 600;
  color: #1b2f4a;
  margin-bottom: 0.75rem;
`

export const SkillList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
`

export const SkillItem = styled.div`
  padding: 0.6rem 0.7rem;
  border: 1px solid #e8edf4;
  border-radius: 12px;
  background: linear-gradient(180deg, #fbfcfe 0%, #f7f9fc 100%);
`

export const SkillHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.35rem;
`

export const SkillName = styled.div`
  font-family: Poppins;
  font-size: 0.96rem;
  color: #1b2f4a;
  font-weight: 500;
`

export const Score = styled.div`
  color: #115293;
  font-family: Poppins;
  font-size: 0.95rem;
  font-weight: 600;
`

export const SkillProgressTrack = styled.div`
  width: 100%;
  height: 1.15rem;
  border: 1px solid #dfe6f0;
  border-radius: 999px;
  background: #eff3f8;
  overflow: hidden;
`

export const SkillProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #1AA0FF 0%, #166DD8 95.42%);
  border-radius: 999px;
  transition: width 0.35s ease;
`

export const StatsGridSection = styled.div`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e1e7f2;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 1.2rem;
  box-shadow: 0 10px 24px rgba(14, 41, 72, 0.06);
  margin-bottom: 2.8rem;
`

export const StatCircleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`

export const StatCard = styled.div`
  border: 1px solid ${(props) => props.$toneBorder || '#edf2fb'};
  border-radius: 16px;
  padding: 0.95rem;
  text-align: center;
  background: linear-gradient(180deg, ${(props) => props.$toneStart || '#fbfdff'} 0%, ${(props) => props.$toneEnd || '#f5f9ff'} 100%);
  box-shadow: 0 4px 10px rgba(14, 41, 72, 0.04);
`

export const StatLabel = styled.div`
  font-family: Poppins;
  font-size: 0.92rem;
  font-weight: 600;
  color: ${(props) => props.$toneLabel || '#26486f'};
  margin-bottom: 0.55rem;
`

export const CircleWrap = styled.div`
  position: relative;
  width: fit-content;
  margin: auto;
  padding: 0.35rem;
  border-radius: 999px;
  background: ${(props) => props.$toneHalo || '#eaf1ff'};
`

export const Percent = styled.div`
  color: #2f3f55;
  font-weight: 700;
  font-family: Poppins;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48%);
  font-size: 0.86rem;
  min-width: 2.6rem;
  height: 1.65rem;
  line-height: 1.65rem;
  border-radius: 999px;
  background: ${(props) => props.$toneBadge || '#166dd8'};
  border: 1px solid rgba(47, 63, 85, 0.14);
  box-shadow: 0 2px 8px rgba(14, 41, 72, 0.08);
`

export const SelectorStatsContainer = styled.div`
  margin-bottom: 1rem;
  margin-top: 1rem;
`

export const StatsSelector = styled(Select)`
.react-select__control {
  border-radius: 12px;
  width: 100%;
  color: #182f4f;
  font-family: Poppins;
  font-size: 13px;
  outline: none;
  border: 1px solid #d5deeb;
  height: 2.75rem;
  cursor: pointer;
  padding-left: 2.25rem;
  background-image: url(${statsLogo});
  background-size: 1rem;
  background-position: top 45% left 1rem;
  background-repeat: no-repeat;
}
.react-select__option {
  font-family: Poppins;
  font-size: 13px;
  cursor: pointer;
}
.react-select__indicator-separator {
  display: none;
}
.react-select__dropdown-indicator {
  color: #334f72;
}
  & .react-select__control--is-focused {
    box-shadow: 0 0 0 3px rgba(22, 109, 216, 0.15);
    border-color: #8fb8ea;
  }
`
